// extracted by mini-css-extract-plugin
export default {"titleQuestion":"RegisterAuditorFormStepEight_titleQuestion__gpIBv"};